import { combineReducers } from 'redux';

import acousticSettingsReducer from './acousticSettings';
import audioFilesReducer from './audioFiles';
import audioPlaybackReducer from './audioPlayback';
import loadedAudioFilesReducer from './loadedAudioFiles';
import setPiecesReducer from './setPieces';
import settingsReducer from './settings';
import stageReducer from './stage';
import timelineReducer from './timeline';
import audioReducer from './audio';
import { undoReducer } from './undo';

// Combines reducers together so we can access all of them in one store
const reducers = undoReducer(
	// Not undoable
	combineReducers({
		audioPlayback: audioPlaybackReducer,
		loadedAudioFiles: loadedAudioFilesReducer,
		settings: settingsReducer,
		audio: audioReducer,
	}),
	// Undoable
	combineReducers({
		acousticSettings: acousticSettingsReducer,
		audioFiles: audioFilesReducer,
		setPieces: setPiecesReducer,
		stage: stageReducer,
		timeline: timelineReducer,
	})
);

export default reducers;

// use types so we can see all the different reducer data types when accessing them
// very handy!
export type RootState = ReturnType<typeof reducers>;
